import { CommentModal } from 'components/CommentModal';
import { DownloadModal } from 'components/DownloadModal';
import { DownloadPinModal } from 'components/DownloadPinModal';
import { PhotographerModal } from 'components/PhotographerModal';
import { SaveSelectionModal } from 'components/SaveSelectionModal';
import { SelectionSentCongratsModal } from 'components/SelectionSentCongratsModal';
import { SendSelectionModal } from 'components/SendSelectionModal';
import { SingleImageDownloadModal } from 'components/SingleImageDownloadModal';
import { DownloadTourModal } from 'components/Tours/DowloadTourModal';

import { LegacyAuthModals } from './LegacyAuthModals';

export const LegacyGlobalModalHost: React.FC = () => (
  <>
    <DownloadModal />
    <PhotographerModal />
    <SingleImageDownloadModal />
    <DownloadPinModal />
    <DownloadTourModal />
    <CommentModal />
    <SendSelectionModal />
    <SaveSelectionModal />
    <SelectionSentCongratsModal />
    <LegacyAuthModals />
  </>
);
